import { useState } from "react";
import { Email } from "../../Email/Email";
import { Form } from "../../Form/Form";
import { useTranslation } from "react-i18next";
import "./InfoCollection.scss";

export const InfoCollection = ({
  emailEnabled,
  updateEmail,
  questionsData,
  onComplete,
}) => {
  const { i18n } = useTranslation();
  const [userInfo, setUserInfo] = useState({});
  const [activeStep, setActiveStep] = useState(emailEnabled ? 0 : 1);

  const loadNextStep = (data) => {
    if (questionsData.length < 1 || activeStep > 0) {
      onComplete({ ...userInfo, ...data, lang: i18n.language });
    } else {
      setUserInfo((prevData) => ({ ...prevData, ...data }));
      setActiveStep((prevValue) => prevValue + 1);
    }
  };

  const totalLength = emailEnabled
    ? questionsData.length + 1
    : questionsData.length;

  return (
    <div className="info-collection">
      {totalLength > 1 && (
        <div className="info-step-indicator">
          {Array.from({ length: totalLength }).map((_, i) => (
            <div
              key={i}
              className={`info-progress-style ${i <= activeStep - 1 ? "completed" : ""}`}
            />
          ))}
        </div>
      )}

      {activeStep === 0 ? (
        <Email updateEmail={updateEmail} updateUserInfo={loadNextStep} />
      ) : (
        <Form
          formData={questionsData}
          onComplete={loadNextStep}
          onNextQuestion={() => setActiveStep((prevValue) => prevValue + 1)}
        />
      )}
    </div>
  );
};
